export default __webpack_public_path__ + "446818aa1e7e27de99942d449362e40c.svg";